import { Step, StepLabel, Stepper } from '@mui/material'
import { Trans } from '@lingui/macro'

export function MergeStep({ activeStep }: { activeStep: number }) {
  return (
    <Stepper activeStep={activeStep} sx={{ pt: 2, pb: 3 }}>
      <Step>
        <StepLabel>
          <Trans>Select Primary Patient</Trans>
        </StepLabel>
      </Step>
      <Step>
        <StepLabel>
          <Trans>Select Secondary Patient</Trans>
        </StepLabel>
      </Step>
      <Step>
        <StepLabel>
          <Trans>Review & Merge</Trans>
        </StepLabel>
      </Step>
    </Stepper>
  )
}
